import { useNavigate } from "react-router-dom";
// import product from "../../../assests/HPE/Landing-page/s_product.webp";
// import Button from "../../common/Button";
// import ScrollText from "../../ScrollText/ScrollText";
import { useRef } from "react";
// import ProgressStep from "../../common/ProgressStep";
// import Formpage from "../../../pages/Formpage/";
// import monitor from "../../../assests/HPE/Landing-page/hpe-cloud/icon-1.svg";
// import clock from "../../../assests/HPE/Landing-page/hpe-cloud/icon-2.svg";
// import security from "../../../assests/HPE/Landing-page/hpe-cloud/icon-3.svg";
// import hp from "../../../assests/HPE/Landing-page/hpe-cloud/icon-4.svg";
// import FeatureCard from "../homepage/FeatureCard";
import { FeatureSectionZerto } from "./FeatureSectionZerto";
import FormZerto from "../formpage/FormZerto";

// import Page1Content from "./Page1Content";

const MastheadZerto = () => {
  const navigate = useNavigate();
  const firstNameRef = useRef(null);

  const navigateToForm = (e) => {
    e.preventDefault();
    const params = new URLSearchParams(window.location.search);
    const utm_source = params.get("utm_source") || "";
    const utm_medium = params.get("utm_medium") || "";
    const utm_campaign = params.get("utm_campaign") || "";

    navigate("/form", {
      state: {
        first_name: firstNameRef.current?.value.trim(),
        utm_source,
        utm_medium,
        utm_campaign,
      },
    });
  };
  return (
    <>
      <div
        className="w-full h-full bg-m-masthead-bg-zerto sm:bg-form-masthead-bg-zerto bg-no-repeat bg-[length:100%_40rem] pt-36 md:pt-[121px]
      before:absolute before:inset-0 before:bg-[linear-gradient(180deg,rgba(0,0,0,0.90)_14.15%,rgba(0,0,0,0.00)_123.71%)]
      before:md:bg-[linear-gradient(90deg,rgba(0,0,0,0.90)_-10.69%,rgba(0,0,0,0.18)_73.43%)] before:h-[40rem] before:w-full "
      >
        <section className="container mx-auto">
          <div className="flex-col justify-between items-start lg:flex lg:flex-row md:px-4 px-0 md:mx-12 mx-0">
            <div className="flex flex-col gap-10 lg:gap-[183px] 2xl:gap-[250px] lg:w-[50%] w-full">
              <div className="w-full flex flex-col gap-10 mb-11 lg:mb-0 z-10">
                <div className=" w-full flex flex-col gap-4">
                  <div className="h2 !font-semibold text-white">
                    Recover in Seconds. <br />
                    Not Hours. Not Days.
                  </div>
                  <p className="b3 text-grey-01">
                    Ransomware doesn't wait. Neither should your recovery. HPE
                    Zerto Software delivers continuous data protection,
                    real-time ransomware detection, and near-zero RPO/RTO — so
                    your business bounces back before the damage compounds.
                  </p>
                </div>

                <div className="flex items-center gap-8">
                  <div className="flex flex-col gap-3">
                    <h3 className="text-orange-06 !font-medium">{"<60s"}</h3>
                    <p className="text-white b5">Recovery time objective</p>
                  </div>
                  <div className="flex flex-col gap-3">
                    <h3 className="text-orange-06 !font-medium">{"~0"}</h3>
                    <p className="text-white b5">
                      Data loss with continuous replication
                    </p>
                  </div>
                  <div className="flex flex-col gap-3">
                    <h3 className="text-orange-06 !font-medium">3-in-1</h3>
                    <p className="text-white b5">
                      DR + Backup + Ransomware resilience
                    </p>
                  </div>
                </div>
              </div>

              <FeatureSectionZerto className="hidden lg:flex" />
            </div>
            <FormZerto />

            <FeatureSectionZerto className="flex lg:hidden" />
          </div>
        </section>
      </div>
    </>
  );
};

export default MastheadZerto;
